import React from "react";
import { Button } from "../ui/button";
import { useN2Offer } from "../../lib/useN2Offer";
import { formatCOP } from "../../lib/apiClient";

/**
 * Bloque CTA para solicitar/continuar con Kit Documental (N2).
 */
export function N2CtaBlock({ state, acting, onAcceptN2, onResumeN2Payment, onEditN2Intake, contactReq, onRequestContact }) {
  const n2Offer = useN2Offer();
  return (
    <div className="border border-primary/30 bg-primary/[0.03] p-6" data-testid="n2-cta-block">
      <p className="text-[11px] uppercase tracking-widest text-primary font-medium mb-2">
        Kit Documental
      </p>
      <h3 className="font-serif text-xl text-gray-900 mb-2">
        {state === "nivel2_payment_pending"
          ? "Continúa con el pago del Kit Documental"
          : "Lleva tu caso al Kit Documental"}
      </h3>
      <p className="text-sm text-gray-700 mb-4">
        Generamos estudios previos, análisis del sector, matriz de riesgos y justificación de
        modalidad — todo revisado por experto humano. Costo: {formatCOP(n2Offer.price_reviewed_cop)} (con revisión humana).
      </p>
      <div className="flex flex-wrap gap-3 items-center">
        <Button
          onClick={state === "nivel2_payment_pending" ? onResumeN2Payment : onAcceptN2}
          disabled={acting}
          className="rounded-sm h-11"
          data-testid="case-accept-n2-cta"
        >
          {acting
            ? "Procesando…"
            : state === "nivel2_payment_pending"
              ? "Continuar al pago Kit Documental"
              : "Solicitar Kit Documental"}
        </Button>
        {state === "nivel2_payment_pending" && onEditN2Intake && (
          <Button
            variant="outline"
            onClick={onEditN2Intake}
            disabled={acting}
            className="rounded-sm h-11 border-primary text-primary hover:bg-primary/5"
            data-testid="case-edit-n2-intake-btn"
          >
            Editar intake del Kit Documental
          </Button>
        )}
        {contactReq && contactReq.status === "pending" ? (
          <span className="text-xs text-emerald-700 font-medium" data-testid="n2-contact-pending-pill">
            ✓ Solicitud de contacto enviada — te contactaremos pronto.
          </span>
        ) : (
          <Button
            variant="outline"
            onClick={onRequestContact}
            disabled={acting}
            className="rounded-sm h-11 border-primary text-primary hover:bg-primary/5"
            data-testid="case-request-n2-contact-btn"
          >
            Solicitar contacto comercial
          </Button>
        )}
        <span className="text-xs text-gray-500">
          Sin compromiso. El pago se gestionará en la siguiente pantalla.
        </span>
      </div>
    </div>
  );
}
